/**
 * Lightweight logger that silences non-error output in production builds.
 * `error` always logs (needed for real production diagnostics);
 * `log` / `warn` / `debug` are no-ops when NODE_ENV === 'production'.
 */
const isProd = process.env.NODE_ENV === "production";

const logger = {
  log: (...args) => {
    if (!isProd) console.log(...args);
  },
  warn: (...args) => {
    if (!isProd) console.warn(...args);
  },
  debug: (...args) => {
    if (!isProd) console.debug(...args);
  },
  error: (...args) => console.error(...args),
};

export default logger;
